import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const GOOGLE_MAPS_API_KEY: InjectionToken<string> = new InjectionToken<string>('googleApiAuthToken');
